(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eierbal-price-index"] && !Shopify.designMode) return;
  try {
    

(() => {
 document.querySelectorAll('[data-ebmonitor]').forEach(panel=>{
  const root=panel.closest('[data-eierbal-price-index]');if(!root)return;
  const rows=[...root.querySelectorAll('[data-price-row]')];
  const entries=rows.map(el=>({price:Number(el.dataset.price),province:(el.querySelector('.ebindex-row__place p')?.textContent||'').split('·').pop().trim(),name:el.querySelector('h3')?.textContent?.trim()||''})).filter(x=>Number.isFinite(x.price)&&x.price>0);
  const $=s=>panel.querySelector(s),money=n=>'€ '+n.toLocaleString('nl-NL',{minimumFractionDigits:2,maximumFractionDigits:2});
  const svg=$('[data-ebmonitor-chart]'),path=$('[data-ebmonitor-path]'),grid=$('[data-ebmonitor-grid]'),dot=$('[data-ebmonitor-dot]'),tip=$('[data-ebmonitor-tip]');
  let points=[],items=[];
  function render(){
   const region=$('[data-ebmonitor-region]').value;items=entries.filter(x=>region==='all'||x.province===region).sort((a,b)=>a.price-b.price);
   if(!items.length){path.setAttribute('d','');tip.textContent='Nog geen gecontroleerde prijzen voor deze regio.';return;}
   const vals=items.map(x=>x.price),n=vals.length,avg=vals.reduce((a,b)=>a+b,0)/n,mid=Math.floor(n/2),median=n%2?vals[mid]:(vals[mid-1]+vals[mid])/2;
   $('[data-ebmonitor-average]').textContent=money(avg);$('[data-ebmonitor-median]').textContent=money(median);$('[data-ebmonitor-count]').textContent=String(n);$('[data-ebmonitor-range]').textContent=money(vals[0])+' – '+money(vals[n-1]);
   const lo=Math.floor((vals[0]-.15)*2)/2,hi=Math.ceil((vals[n-1]+.15)*2)/2,span=Math.max(.5,hi-lo);
   points=vals.map((v,i)=>({x:40+(n===1?360:i/(n-1)*720),y:250-(v-lo)/span*215}));
   path.setAttribute('d',points.map((p,i)=>(i?'L':'M')+p.x.toFixed(2)+' '+p.y.toFixed(2)).join(' '));
   grid.innerHTML=[0,1,2,3,4].map(i=>{const y=35+i*53.75;return '<line x1="40" y1="'+y+'" x2="760" y2="'+y+'" stroke="#ddd" stroke-dasharray="4 5"/><text x="3" y="'+(y+4)+'" font-size="12" fill="#333">'+(hi-(i/4)*span).toLocaleString('nl-NL',{maximumFractionDigits:2})+'</text>'}).join('');
   dot.setAttribute('visibility','hidden');tip.textContent=n+' prijzen, gerangschikt van goedkoop naar duur. Beweeg over de lijn voor details.';
  }
  function hover(e){if(!points.length)return;const rect=svg.getBoundingClientRect();const x=(e.clientX-rect.left)/rect.width*800;let idx=0,dist=Infinity;points.forEach((p,i)=>{const d=Math.abs(p.x-x);if(d<dist){dist=d;idx=i}});const p=points[idx];dot.setAttribute('cx',p.x);dot.setAttribute('cy',p.y);dot.setAttribute('visibility','visible');tip.textContent=items[idx].name+' · '+money(items[idx].price)+' · '+(idx+1)+' van '+items.length;}
  svg.addEventListener('pointermove',hover);svg.addEventListener('pointerleave',()=>dot.setAttribute('visibility','hidden'));$('[data-ebmonitor-region]').addEventListener('change',render);render();
 });
})();

(() => {
  document.querySelectorAll('[data-eierbal-price-index]').forEach(root => {
    const list = root.querySelector('[data-price-index-list]');
    if (!list) return;

    const rows = Array.from(list.querySelectorAll('[data-price-row]'));
    rows.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
    rows.forEach((row,index) => {
      const rank = row.querySelector('[data-price-rank]');
      if (rank) rank.textContent = String(index + 1).padStart(2,'0');
      list.appendChild(row);
    });

    const prices = rows
      .map(row => Number(row.dataset.price))
      .filter(price => Number.isFinite(price) && price > 0)
      .sort((a,b) => a - b);
    if (!prices.length) return;

    const middle = Math.floor(prices.length / 2);
    const median = prices.length % 2
      ? prices[middle]
      : (prices[middle - 1] + prices[middle]) / 2;

    const baselineMedian = 3.5;
    const indexValue = (median / baselineMedian) * 100;
    const formatNumber = value => value.toLocaleString('nl-NL', {minimumFractionDigits: 1, maximumFractionDigits: 1});
    const formatPrice = value => value.toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2});

    root.querySelectorAll('[data-index-value]').forEach(el => el.textContent = formatNumber(indexValue));
    root.querySelectorAll('[data-index-median]').forEach(el => el.textContent = formatPrice(median));
    root.querySelectorAll('[data-index-sample]').forEach(el => el.textContent = String(prices.length));

    const delta = Math.max(-15, Math.min(15, indexValue - 100));
    const y = 70 - (delta * 3);
    const trend = root.querySelector('[data-index-trend]');
    const point = root.querySelector('[data-index-current-point]');
    const label = root.querySelector('[data-index-point-label]');
    if (trend) trend.setAttribute('y2', y.toFixed(2));
    if (point) point.setAttribute('cy', y.toFixed(2));
    if (label) {
      label.setAttribute('y', String(Math.max(16, y - 12)));
      label.textContent = formatNumber(indexValue);
    }
  });
})();

document.querySelectorAll('[data-regional-compare]').forEach(region => {
  const select = region.querySelector('[data-regional-select]');
  const priceEl = region.querySelector('[data-regional-price]');
  const countEl = region.querySelector('[data-regional-count]');
  const deltaEl = region.querySelector('[data-regional-delta]');
  if (!select || !priceEl || !countEl || !deltaEl) return;

  const groups = new Map();
  region.querySelectorAll('[data-regional-province][data-regional-price-value]').forEach(item => {
    const province = (item.dataset.regionalProvince || '').trim();
    const price = Number(item.dataset.regionalPriceValue);
    if (!province || !Number.isFinite(price) || price <= 0) return;
    if (!groups.has(province)) groups.set(province, []);
    groups.get(province).push(price);
  });

  const provinces = Array.from(groups.keys())
    .filter(province => province.toLowerCase() !== 'groningen')
    .sort((a,b) => a.localeCompare(b, 'nl'));

  provinces.forEach(province => {
    const option = document.createElement('option');
    option.value = province;
    option.textContent = province;
    select.appendChild(option);
  });

  const groningenAverage = Number(region.dataset.groningenAverage);
  const formatPrice = value => value.toLocaleString('nl-NL', {minimumFractionDigits:2, maximumFractionDigits:2});

  const update = () => {
    const province = select.value;
    const values = groups.get(province) || [];
    if (!values.length) {
      priceEl.textContent = '—';
      countEl.textContent = 'Kies een provincie';
      deltaEl.textContent = '';
      deltaEl.removeAttribute('data-tone');
      return;
    }

    const average = values.reduce((sum,value) => sum + value, 0) / values.length;
    priceEl.textContent = formatPrice(average);
    countEl.textContent = values.length + (values.length === 1 ? ' gecontroleerde prijs' : ' gecontroleerde prijzen');

    if (!Number.isFinite(groningenAverage) || groningenAverage <= 0) {
      deltaEl.textContent = '';
      return;
    }

    const difference = average - groningenAverage;
    if (Math.abs(difference) < 0.005) {
      deltaEl.textContent = 'Gelijk aan Groningen';
      deltaEl.dataset.tone = 'equal';
    } else if (difference > 0) {
      deltaEl.textContent = '€ ' + formatPrice(Math.abs(difference)) + ' hoger dan Groningen';
      deltaEl.dataset.tone = 'higher';
    } else {
      deltaEl.textContent = '€ ' + formatPrice(Math.abs(difference)) + ' lager dan Groningen';
      deltaEl.dataset.tone = 'lower';
    }
  };

  if (provinces.length) {
    select.value = provinces.includes('Drenthe') ? 'Drenthe' : provinces[0];
    update();
  }

  select.addEventListener('change', update);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
